import { render, staticRenderFns } from "./ExpiredTemplate.vue?vue&type=template&id=1c794f26"
import script from "./ExpiredTemplate.vue?vue&type=script&lang=js"
export * from "./ExpiredTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports